import { Component, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ManageService } from '../../../Dashboard/services/manage.service';
import { StatusService } from '../../../Common/services/status.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DatePipe } from '@angular/common';
import { UserLogin } from '../../../Common/models/user.login';
import { VerificationService } from '../../services/verification.service';
import { ProjectVerification, FilterCriteria, ProjectFiles } from '../../models/projectverification';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { StorageService } from '../../../Common/services/storage.service';
import { RolesKeysConstants, Verification, VerificationMessage, VerificationStatus } from '../../../Common/Constants/data';
import { ProjectReportService } from '../../services/project-report.service';
import { ProjectReport } from '../../models/projectreport';
import { FileUploadComponent } from '../../Common/file-upload/file-upload.component';
import { FileUploadModel } from '../../../shared/flexible-file-upload/flexible-file-upload.component';
import { ConfirmationService } from 'primeng/api';
import { ErrorLoggerService } from '../../../shared/services/error-logger.service';
import { MessageService } from '../../../project-intake/services/message.service';
import { CustomEncodeDecodeService } from '../../../Common/services/custom-encode-decode.service';
import { UserRoleServiceService } from '../../../shared/services/user-role-service.service';
import { VendorService } from '../../../Common/services/vendor.service';

@Component({
  selector: 'app-verification-dashboard',
  templateUrl: './verification-dashboard.component.html',
  styleUrl: './verification-dashboard.component.css',
})
export class VerificationDashboardComponent {
  // @ViewChild('fileUpload', { static: false }) fileUpload!: FileUploadComponent;
  @ViewChild('fileUpload') fileUploadComponent!: FileUploadComponent;

  verificationData: ProjectVerification[] = [];
  tempVerificationData: ProjectVerification[] = [];
  selectedProjectVerificationData!: ProjectVerification;
  selectedProjectFilesData!: ProjectFiles[];
  selectedProjectFiles!: ProjectFiles[];
  selectedProjectReportOption: number = 0;

  public selectedVendor: any;
  public selectedVendorID: any;
  categoryList: any[] | undefined = [];
  selectedCategories: any[] = [];
  statusList: any[] | undefined = [];
  vendorId?: string;
  storeVendor: any;
  orgID: number = 0;
  orgIDBySelectedVendor: number = 0;
  loggedInUserID: number = 0;

  selectedCategory?: string;
  selectedStatus?: string;
  txtSearchProjectTitle?: string;
  selectedDateRange: any;
  selectedStartDate1?: string;
  selectedStartDate2?: string;

  allowMultipleFiles: boolean = false;
  allowedFileTypeExtensions: string = '.xlx,.xlsx';

  msgNoVerification: string = '';

  constructor(private route: ActivatedRoute, private router: Router, private verificationService: VerificationService,
    private storageService: StorageService, private ngxService: NgxUiLoaderService, private projectReportService: ProjectReportService,
    private confirmationService: ConfirmationService, private msgService: MessageService,
    private errorLogService: ErrorLoggerService, private encodeDecodeService: CustomEncodeDecodeService,
    private userRoleService: UserRoleServiceService, private vendorService: VendorService

  ) { }

  ngOnInit(): void {
    this.getUserRoleInfo();
    if (this.userRoleService.role ?.roleKey == RolesKeysConstants.RoleKey_CustomerTeam
      || this.userRoleService.role ?.roleKey == RolesKeysConstants.RoleKey_ITAdmin
        || this.userRoleService.role ?.write == false ) {
      //alert('Unauthorized Access');
      this.router.navigate(['/unauthorized']);
    }

    this.statusList = Verification.ProjectReportStatus;
    this.loadProjectVerification();

    localStorage.setItem('projectTitleForVerification', '');
    this.msgNoVerification = VerificationMessage.PROJECT_VERIFICATION_NOTEXISTS;
  }

  //#region User Role Info
  getUserRoleInfo() {
    this.storeVendor = this.storageService.getItem<any>("selectedVendor");
    this.vendorId = this.storeVendor.vendorID;
    this.orgIDBySelectedVendor = this.storeVendor.orgID;

    let encodedVal = localStorage.getItem('UserRoleInfo');
    if (encodedVal != null) {

      let userRoleInfo: UserLogin = JSON.parse(atob(encodedVal));
      this.selectedVendor = userRoleInfo.vendors[0];
      this.selectedVendorID = this.selectedVendor.vendorID;
      this.vendorService.selectedVendor(this.selectedVendor.vendorName);
      this.loggedInUserID = userRoleInfo.userID;
      //userRoleInfo.categories =  userRoleInfo.categories?.filter(v=>v.vendorID == this.selectedVendor.vendorID);
      this.categoryList = userRoleInfo.categories;
    }
  }
  //#endregion

  // #region Load Project Verification Data
  loadProjectVerification() {
    this.ngxService.start();

    this.verificationService.GetProjectVerificationByVendorId(Number(this.vendorId))
      .pipe(
        catchError(error => {
          this.ngxService.stop();
          //console.error('Error fetching images:', error);
          this.errorLogService.logError(error, 'loadProjectVerification > Error fetching images:');
          return of([]); // Return an empty result to continue the stream
        })
      )
      .subscribe(projectVerificationdata => {
        this.verificationData = projectVerificationdata;
        this.tempVerificationData = JSON.parse(JSON.stringify(this.verificationData));
        this.ngxService.stop();
      });
  }

  getStatusClass(status?: string): string {
    switch (status) {
      // case 'Completed':
      //   return 'statusText completedText';
      case 'Verified':
        return 'statusText completedText';
      case 'In Progress':
        return 'statusText inprogressText';
      case 'Pending':
        return 'statusText pendingText';
      case 'Pending - Verification Start':
        return 'statusText pendingText';
      case 'Pending - File Processing':
        return 'statusText pendingText';
      default:
        return '';
    }
  }

  getStatusClassForProjectReport(status?: string): string {
    switch (status) {
      case 'VERIFIED':
        return 'statusText completedText';
      case 'PROCESSED':
        return 'statusText inprogressText';
      case 'PENDING':
        return 'statusText pendingText';
      default:
        return '';
    }
  }
  //#endregion

  // #region Navigation
  NavigateToVerificationPage(id?: number, projectTitle?: string) {
    this.setProjectTitle(projectTitle);
    //this.router.navigate(['/verification/ImageCard', id]);
    this.router.navigate(['/verification/ImageCard', this.encodeDecodeService.encode(id)]);
  }

  setProjectTitle(projectTitle?: string) {
    this.verificationService.changeProjectTitle(projectTitle);
    localStorage.setItem('projectTitleForVerification', projectTitle!);
  }
  //#endregion

  // #region Filter

  onProjectTitleChange(event: any) {
    // const target = event.target as HTMLInputElement;
    // const value = target ?.value ?? '';
    this.filteredProjects();
  }

  onSelectedCategory(event: any) {
    const categoryNames = event.map((x: { categoryName: string }) => x.categoryName.trimEnd()).join(',');
    this.selectedCategory = categoryNames;
    //if(this.selectedCategory !== "-1"){
    this.filteredProjects();
    //}
  }

  onSelectedStatus(event: any) {
    this.selectedStatus = event.target.value;
    //if(this.selectedStatus !== "-1"){
    this.filteredProjects();
    //}
  }

  getFilterCriteria() {

    const criteria: FilterCriteria = {
      projectTitle: this.txtSearchProjectTitle,
      categoryName: this.selectedCategory !== '-1' ? this.selectedCategory : undefined,
      startDate1: this.selectedStartDate1,
      startDate2: this.selectedStartDate2,
      status: this.selectedStatus !== '-1' ? this.selectedStatus : undefined,
    };

    return criteria;
  }

  filteredProjects() {
    
    let criteria: FilterCriteria = this.getFilterCriteria();
      
    const filterProjects = this.tempVerificationData.filter(project => {
      const matchesTitle = criteria.projectTitle
        ? project.projectTitle?.toLowerCase().includes(criteria.projectTitle.toLowerCase()) ?? false
        : true;
  
      const matchesCategory = criteria.categoryName
        ? project.categoryName === criteria.categoryName
        : true;
  
      const matchesStatus = criteria.status
        ? project.lstProjectFiles?.some(file => file.status === criteria.status)
        : true;
  
      const matchesStartDate = (criteria.startDate1 && criteria.startDate2)
        ? new Date(project.startDate ?? 0) >= new Date(criteria.startDate1 ?? 0) && new Date(project.startDate ?? 0) <= new Date(criteria.startDate2 ?? 0)
        : true;
  
      return matchesTitle && matchesCategory && matchesStatus && matchesStartDate;
    });
  
    this.verificationData = filterProjects;
  }

  normalizeAndCompare(input: string, query: string): boolean {
    const normalize = (str: string): string[] => {
      return str.toLowerCase().split(',').map(s => s.trim()).sort();
    };

    const normalizedInput = normalize(input);
    const normalizedQuery = normalize(query);

    // Compare if both normalized arrays are identical
    return JSON.stringify(normalizedInput) === JSON.stringify(normalizedQuery);
  }

  ClearFilterSelection() {
    this.txtSearchProjectTitle = '';
    this.selectedCategory = '-1';
    this.selectedDateRange = [];
    this.selectedStatus = '-1';
    this.verificationData = this.tempVerificationData;
  }

  selectedSubmittedDateRange() {
    if (this.selectedDateRange == null) {
      this.selectedStartDate1 = undefined;
      this.selectedStartDate2 = undefined;
      this.filteredProjects();
    }
    else if (this.selectedDateRange ?.length == 2 && this.selectedDateRange.every((a: any) => a != null)) {
      this.selectedStartDate1 = this.selectedDateRange[0];
      this.selectedStartDate2 = this.selectedDateRange[1];
      this.filteredProjects();
    }
  }

  // #endregion

  // #region Download Project Report
  downloadProjectReportExcel(event: Event, projectFilesData?: ProjectFiles): void {
    event.preventDefault();
    event.stopPropagation();

    if (!projectFilesData) {
      return;
    }

    let fileName = "";
    if (projectFilesData.filePath != null) {
      this.ngxService.start();
      fileName = projectFilesData.filePath;

      this.projectReportService.DownloadProjectReportDocument(projectFilesData.projectID, projectFilesData.projectFileID, fileName)
        .pipe(
          catchError(error => {
            this.ngxService.stop();
            this.msgService.htmlError(VerificationMessage.PROJECTREPORT_DOWNLOAD_FAILED);
            return of<void>();
          })
        )
        .subscribe(data => {
          this.downloadFile(data, fileName);
          this.msgService.htmlSuccess(VerificationMessage.PROJECTREPORT_DOWNLOAD_SUCCESS);
          this.ngxService.stop();
        });
    }
    else {
      this.msgService.htmlError(VerificationMessage.PROJECTREPORT_DOWNLOAD_FAILED);
      return;
    }

  }

  downloadFile(blob: Blob, fileName: string): void {
    let downloadLink = fileName;
    if (blob) {
      const a = document.createElement('a');
      const objectUrl = URL.createObjectURL(blob);
      a.href = objectUrl;
      a.download = downloadLink;
      a.click();
      URL.revokeObjectURL(objectUrl);
    } else {
      alert('Download link or blob is not set.');
    }
  }

  stopPropagation(event: Event) {
    event.stopPropagation();
  }
  //#endregion

  // #region Upload Project Report
  openFileDialog(selectedOption: number): void {
    this.selectedProjectReportOption = selectedOption;

    if (this.selectedProjectReportOption == 3 && this.selectedProjectFiles === undefined) {
      this.msgService.htmlError(VerificationMessage.PROJECTREPORT_OVERWRITE_DATENOTSELECTED);
      return;
    }

    if (this.fileUploadComponent) {
      this.fileUploadComponent.agencyId = this.selectedProjectVerificationData.agencyID;
      this.fileUploadComponent.agencyName = this.selectedProjectVerificationData.agencyName!;
      this.fileUploadComponent.triggerFileInput();
    }
  }

  onFilesChanged(files: Array<{ name: string, base64: string }>) {

    if (files[0].name !== 'Invalid' && files[0].base64 != '') {
      //0 - New file, 1 - Add New Records, 2 - Delete , 3 - Overwrite
      if (this.selectedProjectReportOption == 2) {
        const projectFileIDs = this.selectedProjectVerificationData ?.lstProjectFiles ?.map(file => file.projectFileID);
        this.DeleteProjectReportData(this.selectedProjectVerificationData.projectID!, projectFileIDs);
      }
      if (this.selectedProjectReportOption == 3) {
        const projectFileIDs = this.selectedProjectFiles ?.map(file => file.projectFileID);
        this.DeleteProjectReportData(this.selectedProjectVerificationData.projectID!, projectFileIDs);
      }
      this.UploadProjectReportDocument(files[0].name, files[0].base64);
    }
    else {
      this.msgService.htmlError(VerificationMessage.PROJECTREPORT_INVALID_EXCEL);
    }
  }

  UploadProjectReportDocument(fileName: string, base64: string) {
    var objProjectReport = new ProjectReport();
    objProjectReport.ProjectID = this.selectedProjectVerificationData.projectID;
    objProjectReport.ProjectTitle = this.selectedProjectVerificationData.projectTitle;
    objProjectReport.AgencyName = this.selectedProjectVerificationData.agencyName;
    objProjectReport.DocumentObj = base64.substr(base64.indexOf(',') + 1);
    objProjectReport.DocumentName = fileName;
    objProjectReport.CreatedBy = this.loggedInUserID;

    this.ngxService.start();
    this.projectReportService.UploadProjectReportDocument(objProjectReport).subscribe(x => {
      this.msgService.htmlSuccess(VerificationMessage.PROJECTREPORT_UPLOAD_SUCCESS);

      //Changing status (Pending - File Processing) after uploading the Agency Report 
      this.selectedProjectVerificationData.status = VerificationStatus.PENDING_FILE_PROCESSING;
      this.UpdateVerificationStatus(this.selectedProjectVerificationData);

      this.ngxService.stop();
    });
  }
  //#endregion

  UpdateVerificationStatus(projectVerificationdata: ProjectVerification, isCompleteVerification: boolean = false) {
    this.verificationService.UpdateProjectVerificationStatus(projectVerificationdata)
      .pipe(
        catchError(error => {
          console.error('Error Updating status:', error);
          return of(false);
        })
      )
      .subscribe(x => {
        if (x && isCompleteVerification) {
          this.msgService.htmlSuccess(VerificationMessage.PROJECT_VERIFICATION_SUCCESS);
        }
        this.loadProjectVerification();
      });
  }

  UpdateVerificationCompleteStatus(projectVerificationdata: ProjectVerification) {
    this.confirmationService.confirm({
      header: VerificationMessage.PROJECT_VERIFICATION_CONFIRMATION_HEADER,
      icon: 'pi pi-exclamation-triangle',
      message: VerificationMessage.PROJECT_VERIFICATION_CONFIRMATION,
      accept: () => {
        projectVerificationdata.status = VerificationStatus.VERIFIED;
        projectVerificationdata.changedBy = this.loggedInUserID;
        this.UpdateVerificationStatus(projectVerificationdata, true);
      },
      reject: () => {
      }
    });
  }

  selectProjectVerificationData(proj: any) {

    this.selectedProjectVerificationData = proj;
    this.selectedProjectFilesData = proj.lstProjectFiles;

    //Open the file dialog without popup confirmation. Which means no existing project files
    if (proj.lstProjectFiles.length == 1 && proj.lstProjectFiles[0].projectID == 0) {
      this.openFileDialog(0);
    }
  }

  DeleteProjectReportData(projectId: number, projectFileIDs: any) {
    this.projectReportService.DeleteProjectReportData(this.selectedProjectVerificationData.projectID, projectFileIDs).subscribe(x => {
    });
  }

}